import { sortOffersByDate } from 'lib/utils/my-account'
import AccountItem from 'components/Teasers/AccountItem'
import NoOffers from './NoOffers'
import styles from './OfferList.module.scss'

export default function OfferList({ offers }) {
  if (!offers) return null

  const sortedOffers = sortOffersByDate(offers)

  return (
    <section>
      {offers.length === 0 && <NoOffers />}

      {sortedOffers.size > 0 &&
        Array.from(sortedOffers).map(([date, offersOfDate]) => (
          <div key={date} className={styles.dateGroup}>
            <h2 className={styles.date}>{date}</h2>
            {offersOfDate.map((offer) => (
              <AccountItem key={offer.id} item={offer} />
            ))}
          </div>
        ))}
    </section>
  )
}
